import React from "react";
import { useTranslation } from "react-i18next";
import { useBoardStore } from "../../../stores/boardStore";
import { useAuthStore } from "../../../stores/authStore";

interface BoardCurrencyButtonProps {
    onClick: () => void;
    className?: string;
}

export const BoardCurrencyButton: React.FC<BoardCurrencyButtonProps> = ({ onClick, className = "" }) => {
    const { t } = useTranslation("common");

    // Currency State
    const currencySettings = useBoardStore((state) => state.currencySettings);

    // Derived currency state
    const { user } = useAuthStore.getState();
    const boardCurrency = currencySettings?.default || user?.currency || "";
    // Show warning if there are any active conversions that are NOT manual (i.e. using automatic rates)
    const hasUncheckedRates = currencySettings?.conversions?.some(c => !c.manual) ?? false;

    // Get currency symbol
    const getCurrencySymbol = (code: string) => {
        const symbols: { [key: string]: string } = {
            USD: "$", EUR: "€", GBP: "£", JPY: "¥", CAD: "CA$", AUD: "A$",
            CHF: "CHF", CNY: "¥", INR: "₹", MXN: "MX$", BRL: "R$",
            ZAR: "R", SEK: "kr", NOK: "kr", DKK: "kr", SGD: "S$",
            HKD: "HK$", KRW: "₩", NZD: "NZ$", TRY: "₺", TND: "DT",
        };
        return symbols[code] || code;
    };

    return (
        <button
            onClick={onClick}
            className={`relative flex items-center justify-center p-2 bg-white dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-800 rounded-lg hover:bg-neutral-50 dark:hover:bg-neutral-800 transition-colors ${className}`}
            title={t("currency.boardCurrency") as string}
        >
            <span className="w-4 h-4 flex items-center justify-center text-sm font-medium text-neutral-500 dark:text-neutral-400">
                {getCurrencySymbol(boardCurrency)}
            </span>
            {hasUncheckedRates && (
                <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-500 rounded-full flex items-center justify-center">
                    <span className="w-2 h-2 text-white" style={{maskImage: `url(https://cdn.dashbal.com/assets/icon_01742d39.svg)`, WebkitMaskImage: `url(https://cdn.dashbal.com/assets/icon_01742d39.svg)`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: 'center', WebkitMaskPosition: 'center', maskSize: 'contain', WebkitMaskSize: 'contain', backgroundColor: 'currentColor', display: 'inline-block'}} role='img' />
                </span>
            )}
        </button>
    );
};
